import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import css from './ApxViewReport.module.css'
import logo from "./../Images/APX.png";
import Grid from '@material-ui/core/Grid';


class DefaultView extends Component {

    render() {
        return (
            <div>
                <Paper className={css.paper} elevation={3} style={{width:"100px"}}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <img src={logo} alt="logo" className={css.logo}></img>
                       
                            <div style={{ alignContent: "center" }}>
                                <p style={{ fontSize: "18px" }}>
                                    You are not authorized to view this page.
                                </p>
                            </div>
                        </Grid>
                       
                    </Grid>

                </Paper>
            </div>
        );
    }
}

export default DefaultView;